import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/logo.webp'
import _imports_1 from '../../assets/img/logo-white.webp'
import _imports_2 from '../../assets/img/icons/apple-store.svg'
import _imports_3 from '../../assets/img/icons/google-play.svg'


const _withScopeId = n => (_pushScopeId("data-v-65547da3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "navbar-wrapper d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-light",
  src: _imports_0,
  alt: "Image"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-dark",
  src: _imports_1,
  alt: "Image"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other-options d-flex align-items-center ms-auto d-lg-none" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "app-btn d-flex align-items-center justify-content-end" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.apple.com/store",
      class: "d-flex flex-column justify-content-center align-items-center rounded-circle"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_2,
        alt: "Image"
      })
    ]),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://play.google.com/store/games?hl=en&gl=US&pli=1",
      class: "d-flex flex-column justify-content-center align-items-center rounded-circle"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_3,
        alt: "Image"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    class: "navbar-toggler d-lg-none",
    "data-bs-toggle": "offcanvas",
    href: "#navbarOffcanvas",
    role: "button",
    "aria-controls": "navbarOffcanvas"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "burger-menu" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "top-bar" }),
      /*#__PURE__*/_createElementVNode("span", { class: "middle-bar" }),
      /*#__PURE__*/_createElementVNode("span", { class: "bottom-bar" })
    ])
  ])
], -1))
const _hoisted_6 = {
  id: "navbar",
  class: "navbar"
}
const _hoisted_7 = { class: "navbar-collapse d-flex justify-content-center" }
const _hoisted_8 = { class: "navbar-nav md-none" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-item has-child" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0)",
  class: "dropdown-toggle"
}, " Pages ", -1))
const _hoisted_16 = { class: "dropdown-menu has-child bg-white" }
const _hoisted_17 = { class: "nav-item has-child" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0)",
  class: "dropdown-toggle"
}, " Portfolio ", -1))
const _hoisted_19 = { class: "dropdown-menu has-child bg-white" }
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = { class: "nav-item has-child" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0)",
  class: "dropdown-toggle"
}, " Shop ", -1))
const _hoisted_24 = { class: "dropdown-menu has-child bg-white" }
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = { class: "nav-item" }
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = { class: "nav-item" }
const _hoisted_30 = { class: "nav-item" }
const _hoisted_31 = { class: "nav-item" }
const _hoisted_32 = { class: "nav-item has-child" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0)",
  class: "dropdown-toggle"
}, " Blog ", -1))
const _hoisted_34 = { class: "dropdown-menu has-child bg-white" }
const _hoisted_35 = { class: "nav-item" }
const _hoisted_36 = { class: "nav-item" }
const _hoisted_37 = { class: "nav-item" }
const _hoisted_38 = { class: "nav-item" }
const _hoisted_39 = { class: "nav-item" }
const _hoisted_40 = { class: "nav-item" }
const _hoisted_41 = { class: "nav-item" }
const _hoisted_42 = { class: "nav-item" }
const _hoisted_43 = { class: "nav-item" }
const _hoisted_44 = { class: "nav-item" }
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div class=\"app-btn d-flex align-items-center justify-content-end ms-auto md-none\" data-v-65547da3><a href=\"https://www.apple.com/store\" target=\"_blank\" class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" data-v-65547da3><img src=\"" + _imports_2 + "\" alt=\"Image\" data-v-65547da3></a><a href=\"https://play.google.com/store/games?hl=en&amp;gl=US&amp;pli=1\" target=\"_blank\" class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" data-v-65547da3><img src=\"" + _imports_3 + "\" alt=\"Image\" data-v-65547da3></a></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    id: "navbar-wrap",
    class: _normalizeClass(['navbar-area', { sticky: _ctx.isSticky }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }),
        _hoisted_5,
        _createElementVNode("nav", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", _hoisted_9, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Home")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_10, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/about-us"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" About Us ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_11, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/pricing-plan"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Pricing Plan ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_12, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/faq"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("FAQ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_13, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/contact-us"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Contact Us ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("ul", _hoisted_16, [
                  _createElementVNode("li", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("ul", _hoisted_19, [
                      _createElementVNode("li", _hoisted_20, [
                        _createVNode(_component_router_link, { to: "/portfolio" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Portfolio ")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_21, [
                        _createVNode(_component_router_link, { to: "/portfolio-details" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Portfolio Details ")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("ul", _hoisted_24, [
                      _createElementVNode("li", _hoisted_25, [
                        _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Shop Left Sidebar ")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_26, [
                        _createVNode(_component_router_link, { to: "/shop-right-sidebar" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Shop Right Sidebar ")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_27, [
                        _createVNode(_component_router_link, { to: "/shop" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Shop Grid ")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_28, [
                        _createVNode(_component_router_link, { to: "/product-details" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Product Details ")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_29, [
                        _createVNode(_component_router_link, { to: "/cart" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Cart")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_30, [
                        _createVNode(_component_router_link, { to: "/wishlist" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Wishlist")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_31, [
                        _createVNode(_component_router_link, { to: "/checkout" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Checkout")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("ul", _hoisted_34, [
                      _createElementVNode("li", _hoisted_35, [
                        _createVNode(_component_router_link, { to: "/blog-left-sidebar" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Blog Left Sidebar ")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_36, [
                        _createVNode(_component_router_link, { to: "/blog-right-sidebar" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Blog Right Sidebar ")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_37, [
                        _createVNode(_component_router_link, { to: "/blog" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Blog Grid ")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_38, [
                        _createVNode(_component_router_link, { to: "/blog-details-left-sidebar" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Blog Details Left Sidebar ")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_39, [
                        _createVNode(_component_router_link, { to: "/blog-details-right-sidebar" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Blog Details Right Sidebar ")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_40, [
                        _createVNode(_component_router_link, { to: "/blog-details" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Blog Details No Sidebar ")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_41, [
                    _createVNode(_component_router_link, { to: "/login" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Login")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_42, [
                    _createVNode(_component_router_link, { to: "/register" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Register")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_43, [
                    _createVNode(_component_router_link, { to: "/terms-conditions" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Terms & Conditions ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_44, [
                    _createVNode(_component_router_link, { to: "/privacy-policy" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Privacy Policy ")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_45
      ])
    ])
  ], 2))
}